import { lazy } from 'react';
import hrefs from './hrefs';

const HomeExercisePlanPage = lazy(() =>
	import('../routableComponents/HomeExercisePlanPage')
);
const OTProgramPlanPage = lazy(() => import('../routableComponents/PlanPage'));
const CoachingPreviouslyAssignedPage = lazy(() =>
	import('../routableComponents/CoachingPreviouslyAssignedPage')
);
const HepPreviouslyAssignedPage = lazy(() =>
	import('../routableComponents/HepPreviouslyAssignedPage')
);
const OTPreviouslyAssignedPage = lazy(() =>
	import('../routableComponents/OTPreviouslyAssignedPage')
);
const VirtualMSKPreviouslyAssignedPage = lazy(() =>
	import('../routableComponents/VirtualMSKPreviouslyAssignedPage')
);
const HEPExerciseDetailsPage = lazy(() =>
	import('../routableComponents/HEPExerciseDetailsPage')
);
const OTExerciseDetailsPage = lazy(() =>
	import('../routableComponents/OTExerciseDetailsPage')
);
const VirtualMSKExerciseDetailsPage = lazy(() =>
	import('../routableComponents/VirtualMSKExerciseDetailsPage')
);

export const ashcareRoutes = [
	{
		href: hrefs.childRoutes.homeExercisePlan,
		component: HomeExercisePlanPage,
	},
	{
		href: hrefs.childRoutes.hepPreviouslyAssigned,
		component: HepPreviouslyAssignedPage,
	},
	{
		href: hrefs.childRoutes.coachingPreviouslyAssigned,
		component: CoachingPreviouslyAssignedPage,
	},
	{
		href: `${hrefs.childRoutes.exerciseDetails}/:actionItemId`,
		component: HEPExerciseDetailsPage,
	},
	{
		href: hrefs.childRoutes.occupationalTherapyPlan,
		component: OTProgramPlanPage,
	},
	{
		href: `${hrefs.childRoutes.occupationalTherapyExerciseDetails}/:actionItemId`,
		component: OTExerciseDetailsPage,
	},
	{
		href: hrefs.childRoutes.occupationalTherapyPreviouslyAssigned,
		component: OTPreviouslyAssignedPage,
	},
];

export const mskRoutes = [
	{
		href: `${hrefs.childRoutes.virtualMSKExerciseDetails}/:actionItemId`,
		component: VirtualMSKExerciseDetailsPage,
	},
	{
		href: hrefs.childRoutes.virtualMSKPreviouslyAssigned,
		component: VirtualMSKPreviouslyAssignedPage,
	},
];
